import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DevelopmentAPI } from "pages/workspace/process/development/development.service";
const initialState = {
  data: [],
  state: ""
};
export const sprintSlice = createSlice({
  name: "sprint",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getSprints.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getSprints.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getSprints = createAsyncThunk('sprints/get', async({ query, workspaceId }) => {
  let data = await DevelopmentAPI.getSprints(query, workspaceId);
  return data['sprints'];

});


export default sprintSlice.reducer;